import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import edit from "../../../../Assets/edit.svg";
import del from "../../../../Assets/Box.svg";

import ExcelIcon from "../../../../Assets/ExcelIcon.svg";
import "../button.css";
import  io  from "socket.io-client";

const socket = io('https://policydekhoo-backend.onrender.com');

const HomeLoan = ({exportToExcel,setData}) => {
  const data=JSON.parse(localStorage.getItem("userData")).Permissions
  const [permissionsList,setpermissionsList]=useState([])
  
  // const top100Films = [
  //   { label: "The Shawshank Redemption", year: 1994 },
  //   { label: "The Godfather", year: 1972 },
  //   { label: "The Godfather: Part II", year: 1974 },
  //   { label: "The Dark Knight", year: 2008 },
  //   { label: "12 Angry Men", year: 1957 },
  //   { label: "Schindler's List", year: 1993 },
  //   { label: "Pulp Fiction", year: 1994 },
  // ];

  useEffect(() => {
    if(data!==null)
      {
    setpermissionsList(data.split(","))
      }
 
    socket.on('dataUpdatedHomeLoan1', (updatedData) => {
        setHomeloandata(updatedData);
        setData(updatedData)
    });    
    socket.on('deleteDataHomeLoan1', (Data) => {
        setHomeloandata(Data);
        setData(Data)
    });
    return () => {
        socket.disconnect();
    };
}, []);

  const currencies = ["value1", "value2", "value3"];

  const rowsPerPageOptions = [5, 10, 25]; // Rows per page options

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [editcheck, seteditcheck] = React.useState(false);
    const [idselected, setidselected] = useState();

    const editdata = (e) => {
      // console.log(e);
      seteditcheck(false);
    };

    const [tableName, settablename] = useState("home_loan");

    const handleDelete = async (id) => {
      try {
        // Store the ID of the row when delete button is clicked
        setidselected(id);
        // console.log("Id to be deleted is : =======", id);

        // Construct the URL with the tableName and idselected
        const url = `https://policydekhoo-backend.onrender.com/Removedata?tableName=${tableName}&id=${id}`;

        // Make a DELETE request to the URL
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        });

        // Check if the request was successful
        if (!response.ok) {
          throw new Error("Failed to delete data");
        }

        // Optionally, you can handle the response here
        const responseData = await response.json();
        const temp=[...Homeloandata]
        let ind=""
        temp.map((val,index)=>{
          if(val.id===id){
            ind=index;
            console.log(val,index)
          }
        })
        temp.splice(ind,1);
        // console.log(temp,"jaiiii");
        // console.log("Delete response:", responseData);
        setHomeloandata(temp)
        setData(temp)
      socket.emit('deleteDataHomeLoan', temp);

        // Refresh the data after deletion
        // Call the function that fetches data again
        // getCarInsurancedata();
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    };

    const [data2, setdata2] = useState({});

    // console.log("data2", data2);

    const UpdateHomeLoan = async (id) => {
      // setidselected(id);
      // console.log("Id to be updated is : =======", id);
      // e.preventDefault();

      try {
        // setidselected(id); // Set the ID first
        // console.log(
        //   "===============data to be updated and id",
        //   data2,
        //   id,
        //   tableName
        // );
        const response = await fetch(
          `https://policydekhoo-backend.onrender.com/Updatedata?tableName=${tableName}&id=${id}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data2),
          }
        );

        if (response.ok) {
          const temp=[...Homeloandata]
          let ind=""
          temp.map((val,index)=>{
            if(val.id===id)
              {
                ind=index
              }
          })
          const temp1={...temp[ind]}
          console.log(temp1,"[][][][][][[[[")    
          Object.keys(data2).map((k1)=>(
            temp1[k1]=data2[k1]
          )) 
          temp[ind]=(temp1);
          setHomeloandata(temp)
          setData(temp)
        socket.emit('editDataHomeLoan', temp);
          console.log("Data updated successfully");

        } else {
          console.error("Failed to update data");
        }
      } catch (error) {
        console.error("Error:", error);
      }
      editdata();
    };

    useEffect(() => {
      // console.log("Id to be deleted is : =======", idselected);
    }, [idselected]);

    return (
      <React.Fragment>
        <TableRow>
          {row.map((val, index) =>
            index <= 3 ? (
              editcheck ? (
                <TableCell align="left">
                  <TextField
                    id="outlined-size-small"
                    defaultValue={val}
                    size="small"
                  />
                </TableCell>
              ) : (
                <TableCell align="left">{val}</TableCell>
              )
            ) : (
              ""
            )
          )}
          <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>
            {row[5] === "pending" ? (
              <label
                className="p-1 px-2 mx-1 rounded  pendng-bg"
                htmlFor="pending"
              >
                <b> Pending</b>
              </label>
            ) : (
              ""
            )}
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[5] === "accepted" ? "accepted-bg" : "border-accepted"
              }   `}
              htmlFor="Accepted"
            >
              <b>Accepted</b>
            </label>
            <label
              className={`p-1 px-2 mx-1 rounded ${
                row[5] === "denied" ? " denied-bg" : "border-denied"
              }`}
              htmlFor="Denied"
            >
              <b>Denied</b>
            </label>
          </TableCell>
          { permissionsList.includes("edit")||permissionsList.includes("delete")?
          <TableCell
            className="text-left"
            sx={{ minWidth: 100, whiteSpace: "nowrap" }}
          >
            {editcheck ? (
              <button
                className="accepted-bg px-3 p-1 rounded border-0 m-1"
                onClick={() => {
                  editdata();
                  UpdateHomeLoan(row[0]);
                }}
              >
                save
              </button>
            ) : (
              ""
            )}
              { permissionsList.includes("edit")?
            <label className="me-1">
              <img
                src={edit}
                alt=""
                onClick={() => {
                  seteditcheck(true);
                }}
              />
            </label>:""}
            { permissionsList.includes("delete")?
            <label className="me-1">
              <img src={del} alt="" onClick={() => handleDelete(row[0])} />
            </label>:""}
          </TableCell>
          :""}
        </TableRow>
      </React.Fragment>
    );
  }

  const [Homeloandata, setHomeloandata] = useState([
    // {
    //   id: 1,
    //   First_Name: "Yash",
    //   Last_Name: "Sukhlani",
    //   Email_Address: "Yash@dfhdfghdf",
    //   Contact_Number: "616514654",
    //   Pincode: "16546545",
    // },
  ]);

  const [tableName, settablename] = useState("home_loan");

  useEffect(() => {
    const getHomeloandata = async () => {
      const url = `https://policydekhoo-backend.onrender.com/GetAllData?tableName=${tableName}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch groups");
        }

        const data = await response.json();
        // console.log("Groups:", data);
        setHomeloandata(data);
        setData(data)
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };

    getHomeloandata();
  }, []);
  console.log(Homeloandata,"[][][][][]");

  const rows = Homeloandata.map((data) => [
    data.id,
    `${data.First_Name} ${data.Last_Name}`,
    data.Email_Address,
    data.Contact_Number,
    data.status,
  ]);

  const Column = ["Unique ID", "Name", "Email", "Contact", "Pincode"];

  return (
    <div className="fade">
      <h3>Home Loan</h3>
      <div className="row ">
        {/* <div className="col-12 my-sm-1 my-2 col-sm-4 col-md-3">
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            // options={top100Films}
            // sx={{ width: 280 }}
            renderInput={(params) => <TextField {...params} label="Search" />}
          />
        </div> */}
        <div className="text-end mx-2">
                  
                  <img src={ExcelIcon} width={"30rem"} className="me-4" alt="excelIcon" style={{cursor:"pointer"}} onClick={exportToExcel} />
        {/* <div className="col-12 my-sm-1 my-2 col-sm-3 col-md-2 ">
          <TextField
            id="outlined-select-currency"
            select
            fullWidth
            label="Status"
            defaultValue={""}
          >
            {currencies.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}
        </div>
      </div>
      <div className="row m-2">
        <Paper sx={{ overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: "60vh" }}>
            <Table aria-label="collapsible table" id="my-table">
              <TableHead>
                <TableRow>
                  {Column.map((val, index) => (
                    <TableCell
                      className="text-left"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <b>{val}</b>
                    </TableCell>
                  ))}
                  <TableCell   sx={{ minWidth: 140 }}className="text-left">
                    <b>Status</b>
                  </TableCell>
                  { permissionsList.includes("edit")||permissionsList.includes("delete")?
                  <TableCell  sx={{ minWidth: 120 }} className="text-left">
                  <b>Action</b>
                </TableCell>
                  :""}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <Row key={row.name} row={row} />
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
};

export default HomeLoan;
